/* Rules from Shopify variant/allocation data; never invent prices or plans. */
(() => {
  'use strict';
  function selection(variant, requested) {
    const allocations=variant.selling_plan_allocations||[];
    const required=Boolean(variant.requires_selling_plan);
    let allocation=allocations.find(a=>String(a.selling_plan.id)===String(requested));
    if(!allocation&&required)allocation=allocations[0];
    return {allocation:allocation||null,planId:allocation?String(allocation.selling_plan.id):'',blocked:!variant.available||(required&&!allocation),price:allocation?allocation.price:variant.price,unitPrice:allocation?.unit_price??variant.unit_price,compareAt:allocation?.compare_at_price??variant.compare_at_price};
  }
  function quantity(value, rule={}) {
    const min=Number(rule.min)||1,increment=Number(rule.increment)||1,max=Number(rule.max)||Infinity;
    const n=Number.isFinite(Number(value))?Number(value):min;
    return Math.min(min+Math.floor((max-min)/increment)*increment,Math.max(min,min+Math.ceil((n-min)/increment)*increment));
  }
  function cartQuantity(current,delta,rule={}){
    const step=Number(rule.increment)||1,next=Number(current)+Number(delta)*step;
    return next<=0?0:quantity(next,rule);
  }
  window.LiotroPurchase={selection,quantity,cartQuantity};
})();
